
<template>
  <v-container>
    <v-row v-if="order">
      <v-col cols="12" md="4" class="pb-0 pt-0">
        <v-card elevation="0" class="mt-3">
          <v-card-title>
            <v-img class="ma-5" contain max-height="50" :src="logo"></v-img>
          </v-card-title>
          <v-card-text>
            <div class="text-subtitle-1 font-weight-bold">{{ order.company_name}}</div>
            <div><span class="font-weight-bold">CNPJ:</span> {{ order.company_cnpj }}</div>
            <div><span class="font-weight-bold">Solução:</span> {{ order.solution }}</div>
          </v-card-text>
        </v-card>
        <v-card elevation="0" class="mt-3">
          <v-card-title>
            Destinatário
          </v-card-title>
          <v-card-text>
            <div><span class="font-weight-bold">Nome:</span> {{ order.client_name }}</div>
            <div><span class="font-weight-bold">CPF/CNPJ:</span> {{ order.client_document }}</div>
          </v-card-text>
        </v-card>
        <v-card elevation="0" class="mt-3 ">
          <v-card-title>
            Link NF-e {{ order.nf }}
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="mx-1" v-bind="attrs" v-on="on" @click="copyNfLink(order.nf_link)" :disabled="!order.nf_link"><v-icon size="20">mdi-content-copy</v-icon></v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="mx-1" v-bind="attrs" v-on="on" @click="openNfLink(order.nf_link)" :disabled="!order.nf_link"><v-icon size="20">mdi-open-in-new</v-icon></v-btn>
              </template>
              <span>Acessar</span>
            </v-tooltip>
            
          </v-card-title>
          <v-card-text v-if="order.nf_link">
            <v-text-field :value="order.nf_link" rows="1"></v-text-field>
            <v-btn large text block outlined color="grey darken-3" @click="openNfLink(order.nf_link)"><v-icon left>mdi-download</v-icon> Baixar</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" class=" pt-0">
        <v-row>
          <v-col cols="12" md="4" class="pb-0">
            <v-card elevation="0" class="mt-3 fill-height">
              <v-card-title>
                Número do pedido
              </v-card-title>
              <v-card-text class="pb-1">
                {{ order.id }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-card elevation="0" class="mt-3 fill-height">
              <v-card-title>
                Data do pedido
              </v-card-title>
              <v-card-text class="pb-1">
                {{ order.created_at }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-card elevation="0" class="mt-3 fill-height">
              <v-card-title>
                Valor do pedido
              </v-card-title>
              <v-card-text class="pb-1">
                {{ order.total_value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-3 pt-3">
            <v-card elevation="0" class="mt-3">
              <v-card-title class="d-flex flex-column align-start">
                <div>Parcela ( {{ order.vrt_transactions.length > 0 ? (order.vrt_transactions.length) : order.payment_methods.length }} )</div>
              </v-card-title>
              <v-card-text class="px-1">
                <PaymentTable 
                  :items="order.vrt_transactions.length > 0 ? order.vrt_transactions : order.payment_methods"
                  :headers="headers"
                  @openBill="openBill"
                  :order="order"
                ></PaymentTable>

                <div class="pt-6" v-if="order.order_bills.length > 0">
                  <v-divider class="mb-3 mx-6"></v-divider>
                  <span style="font-size: 1.12rem; font-weight: 500; letter-spacing: 0.0125em; color: rgba(0, 0, 0, 0.87);" class="px-3 pt-6">Boletos</span>
                  <v-data-table
                    elevation="0"
                    :headers="single_bill_headers"
                    :items="sortedOrderBills"
                    hide-default-footer
                    item-key="name"
                  >
                    <template v-slot:item.nf_due="{item}">
                      {{ item.nf_due }}
                    </template>
                    <template v-slot:item.value="{item}">
                      {{ (parseFloat(item.iugu_bill?.total) || parseFloat(item.value) || 0.0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }} 
                    </template>
                    <template v-slot:item.iugu_bill.status="{item}">
                      <v-chip x-small :color="iugu_status_map[item.iugu_bill.status || item.status].color" text-color="white" class="mr-2">
                        {{ iugu_status_map[item.iugu_bill.status || item.status].text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.actions="{item}">
                      <v-btn icon small :disabled="!item.attached_file_url && !item.iugu_bill" :href="item.attached_file_url || (item.iugu_bill && item.iugu_bill.secure_url)" target="_blank">
                        <v-icon size="20">mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    

                  </v-data-table>
                </div>

              </v-card-text>
            </v-card>
            
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-if="selected_bill">
      <ClientDialogShowBill :bill="selected_bill" :dialog="dialog" @closeDialog="handleCloseDialog"></ClientDialogShowBill>
    </div>


  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '../api/index';
import Logo from "@/assets/logos/cimentao.png";
import PaymentTable from './PaymentTable.vue';

export default {
  name: 'ClientOrderDetails',
  //mixins: [ validations ],
  components: {
    ClientDialogShowBill: () => import('@/_backoffice/_client_order/components/ClientDialogShowBill.vue'),
    PaymentTable: () => import('@/_backoffice/_client_order/components/PaymentTable.vue'),
  },
  data() {
    return {
      logo: Logo,
      order: null,
      dialog: false,
      selected_bill: null,
      single_bill_headers: [
        { text: 'Vencimento', value: 'nf_due', sortable: false },
        { text: 'Situação', value: 'iugu_bill.status', align: 'center', sortable: false },
        { text: 'Valor', value: 'value', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      iugu_status_map: {
        pending: { text: 'Pendente', color: 'orange', icon: '', },
        canceled: { text: 'Cancelado', color: 'red', icon: '', },
        expired: { text: 'Expirado', color: 'red', icon: '', },
        partially_paid: { text: 'Pago parcialmente', color: 'green', icon: '', },
        paid: { text: 'Pago', color: 'green', icon: '', },
        externally_paid: { text: 'Pago Externamente', color: 'green', icon: '', },
        Open: { text: 'Pendente', color: 'orange', icon: '', },
        Concluded: { text: 'Pago', color: 'green', icon: '', },
      },
    }
  },
  methods: {
    handleCloseDialog(){
      this.dialog = false
    },
    openSingleBill(bill){
      this.selected_bill = bill
      this.dialog = true
    },
    openBill(vrt_transaction){
      // moment('2010-10-20').isSame('2009-12-31', 'year')
      
      let due_date = vrt_transaction.due_date
      let [day, month, year] = due_date.split('/');
      let date = new Date(`${year}-${month}-${day}`);
      
      let selected_bill = this.order.order_bills.filter(el=> {
        return this.$moment(el.nf_due).isSame(this.$moment(date).add(12, 'hour'), 'day')
      })
      this.selected_bill = selected_bill[0]
      // this.bill = bill
      this.dialog = true
    },
    getOrder() {
      Api.ClientOrder.show().then(r=>{
        this.order = {
          ...r.data.data.attributes.formated_params,
          vrt_transactions: r.data.data.attributes.vrt_transactions,
          payment_methods: r.data.data.attributes.payment_methods,
          order_bills: r.data.data.attributes.order_bills
        }
      }).catch(err=> {
        console.log(err)
      })
    },
    copyNfLink(url) {
      navigator.clipboard.writeText(url).then(() => {
        alert("Link copiado com sucesso!");
      }).catch(err => {
        console.error("Erro ao copiar o link: ", err);
        alert("Não foi possível copiar o link.");
      })
    },
    downloadURI() {
      fetch(this.order.nf_link)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `nfe-pedido-${this.order.id}`;
        link.click();
      }).catch(console.error);
    },
    openNfLink(url){
      window.open(url, "_blank")
    },
  },
  mounted () {
    this.getOrder();
  },
  computed: {
    sortedOrderBills() {
      if (!this.order || !Array.isArray(this.order.order_bills)) return []

      return this.order.order_bills.slice().sort((a, b) => {
        const rawDueA = a.due_date || a.nf_due
        const rawDueB = b.due_date || b.nf_due
        const dueA = this.$moment(rawDueA, ['DD/MM/YYYY', 'YYYY-MM-DD', this.$moment.ISO_8601], true)
        const dueB = this.$moment(rawDueB, ['DD/MM/YYYY', 'YYYY-MM-DD', this.$moment.ISO_8601], true)

        if (dueA.isValid() && dueB.isValid()) return dueA.valueOf() - dueB.valueOf()
        if (dueA.isValid()) return -1
        if (dueB.isValid()) return 1
        return 0
      })
    },
    headers() {
      if(this.order.vrt_transactions.length > 0){
        return [
          { text: 'Parcela', value: 'idx', sortable: false},
          { text: 'Forma de pagamento', value: 'payment_description', sortable: false },
          { text: 'Vencimento', value: 'due_date', sortable: false },
          { text: 'Situação', value: 'status', align: 'center', sortable: false },
          { text: 'Valor', value: 'ammount', sortable: false },
          { text: 'Valor pago', value: 'ammount_payed', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ] 
      }else{
        return [
          { text: 'Parcela', value: 'idx', sortable: false},
          { text: 'Forma de pagamento', value: 'payment_description', sortable: false },
          { text: 'Vencimento', value: 'due_date', sortable: false },
          { text: 'Situação', value: 'status', align: 'center', sortable: false },
          { text: 'Valor', value: 'ammount', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ]
      }
    }
  },
}
</script>

<style scoped>

.v-sheet.v-card {
  box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 8px 0px;
  border-color: rgba(162, 179, 207, 0.2) !important;
  background-color: white !important;
  box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16), 0 0 0 0.4px rgba(0, 0, 0, 0.08) !important;
  border-top: 4.5px solid #E53935 !important;
}

/* .v-main__wrap {
  background-color: rebeccapurple !important;
} */
.v-card__title {
  word-break: normal;
  font-size: 1.12rem;
}

.v-card__text { 
  font-size: 1rem;

}

span {
  font-size: 1rem;
  font-weight: 400;
}

</style>